export default "__VITE_ASSET__BZ54jMJ9__"